<template>
  <div class="page">
    <div class="mobile-header">
      <i class="el-icon-close close" @click="closed"></i>
      <div class="mobile-header-title">设置常用号码</div>
    </div>

    <div class="container">
      <div class="mobile-content">
        <div class="mobile-input">
          <div class="mobile-wrap">
            <el-input placeholder="请输入电话号码" v-bind:maxlength="phoneNumLen" @input="phoneChange()" v-model="phoneNum" class="input-with-select">
              <el-select slot="prepend" placeholder="+63" value="1">
                <el-option label="+63" value="1">Philippines +63</el-option>
              </el-select>
            </el-input>
          </div>
          <div class="msg-wrap mar-top-10">
            <el-input placeholder="4位短信验证码" oninput="if(value.length>4)value=value.slice(0,4)" v-model="code" type="number" class="input-with-select msg ">
            </el-input>
            <el-button size='mini' round @click="sendCode">{{sendBtn}}</el-button>
          </div>
        </div>
        <div id="captcha_register" ref="captcha" ></div>
        <div class="btn-wrap mar-top-20">
          <el-button class="btn btn-gradient" type="success" @click="submit">保存</el-button>
        </div>
      </div>
      <div class="copyRight">
        © 2013-2021 菲龙网充充充 Inc.
      </div>
    </div>
  </div>

</template>

<script>
	// import '@/util/TCaptcha.js'
  export default {
    name: 'login',
    data() {
      return {
        phoneNum: '',
				phoneNumLen: 11,
        code: '',
        statusBarHeight: 44,
        isShow: true,
        task: false,
        isLoadCaptcha: false,
        validateResult: null,
        showCaptcha: 'none',
        sendBtn: '发送验证码',
        isSendCode: false,
      }
    },
    mounted() {
      let auth_token = localStorage.getItem('auth_token');
      if (!auth_token) {
        this.$router.push('/mine');
      }
    },
    methods: {
      closed() {
        this.$router.push('/mine');
      },
			phoneChange() {
        this.phoneNum = this.phoneNum.replace(/[^\d]/g, '');
				if (/^9\d+$/.test(this.phoneNum)) {
					this.phoneNumLen = 10;
				} else {
					this.phoneNumLen = 11;
				}
			},
      sendCode() {
        if (/^\d+$/.test(this.sendBtn)){
          return;
        }
        if (!/^((09|9)\d{9})$/.test(this.phoneNum)) {
          this.$message({
            type: 'error',
            message: '请输入正确的电话号码!'
          });
         return;
        }
        this.sendBtn = 60;
        //生成一个滑块验证码对象
        var captcha = new TencentCaptcha('2023904603', (result) => {
          console.log("callback:", result);
          if (result.ret == 0) {
            this.$api
              .request('Member/sendCode', {mobile: this.phoneNum, params: result})
              .then(({ data, msg }) => {
                this.isSendCode = true;
                this.$message({
                  message: msg,
                  type: "success"
                })
              })
              .catch(error => {
                this.$message({
                  message: "发送失败！",
                  type: "warning"
                })
              });
          }
        });
        captcha.langFun();
        // 滑块显示
        captcha.show();
        // this.geeinit();
        this.autoSub();
      },
      autoSub() {
        this.sendBtn--;
        if (this.sendBtn > 0) {
          setTimeout(() => {
            this.autoSub();
          }, 1000)
        } else {
          this.$refs.captcha.innerHTML = "";
          this.validateResult = null;
          this.isLoadCaptcha = false;
          this.sendBtn = '发送验证码';
        }
      },
      submit() {
        if (!/^((09|9)\d{9})$/.test(this.phoneNum)) {
            this.$message({
              type: 'error',
              message: '请输入正确的菲律宾号码!'
            });
           return;
         }
         if (!this.isSendCode) {
            this.$message({
              type: 'error',
              message: '请先发送短信验证码!'
            });
           return;
         }
         this.$api
           .request('Member/phoneSet', {mobile: this.phoneNum, code: this.code})
           .then(({ data, msg }) => {
             this.$message({
               message: msg,
               type: "success"
             })
             setTimeout(() => {
              this.$router.push('/mine');
             }, 1000)
           })
           .catch(error => {
             this.$message({
               message: error,
               type: "warning"
             })
           });
      },
    }
  }
</script>


<style scoped lang="less">
  /deep/ .el-select .el-input {
    width: 80px;
  }

  /deep/ .el-input-group__prepend {
    border: none;
    position: relative;
    background-color: transparent;

    &::after {
      content: "";
      width: 1px;
      height: 20px;
      border-left: 1px solid #ebebeb;
      position: absolute;
      right: 0;

    }
  }

  /deep/ .el-input__inner {
    border: none;
  }

  * {
    box-sizing: border-box;
  }

  .page {
    z-index: 2;
    box-sizing: border-box;
    width: 100%;

    .mobile-header {
      background-color: #b22830;
      color: #FFFFFF;
      padding: 20px 15px;

      &-title {
        font-size: 33px;
      }

      &-desc {
        font-size: 20px;
      }
    }
  }

  .container {

    width: 100%;

    .mobile-content {
      font-size: 14px;
      padding: 20px 15px;
      text-align: center;
      position: relative;

      .mobile-input {

        .mobile-wrap,
        .msg-wrap {
          border-bottom: 1px solid #ebebeb;
        }

        .msg-wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .msg {
            width: 200px;
          }

          // padding-right: 100px;
        }
      }
    }

    .btn-wrap {
      .btn.btn-gradient {
        width: 100%;
      }
    }

    .mar-top-10 {
      margin-top: 10px;
    }

    .mar-top-20 {
      margin-top: 20px;
    }

    .flex-center {}

    .title {
      color: #8590a6;
      font-size: 16px;
      text-align: left;
    }

    .copyRight {
      font-size: 13px;
      position: absolute;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      flex-direction: column;
      left: 50%;
      transform: translateX(-50%);
      bottom: 40px;
      color: #8590a6;

    }

  }

  .el-icon-close.close {
    font-size: 24px;
    position: absolute;
    right: 10px;
    top: 10px;

  }

  #captcha_register {
    margin-top: 10px;
    text-align: center;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/phoneset.vue